import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Button from "../../components/Button/Button";
import GenericHeader from "../../components/GenericHeader/GenericHeader";
import { Globals as OldGlobals } from "../../global/Globals";
import Popup from "../../components/PopUp/PopUp";
import BasicDetails from "../ApplyBrief/BasicDetails";
import ProposalDetails from "../ApplyBrief/ProposalDetails";
import CompanyInformation from "../ApplyBrief/CompanyInformation";
import "./EditProposals.css"; // Import the CSS file
import { details } from "../ApplyBrief/ApplyBriefUtils";
import {
  fetch_Brief_Proposals,
  fetchProposalDetails,
  getAllCurrencyName,
  submitProposal,
} from "../../services/applyBriefAPI";
import { useDispatch, useSelector } from "react-redux";
import { updateProposal } from "../../services/api";
import { mapResponseToFormFields, postData } from "./SolictedProposalHook";
import FileUploader from "../../components/FileUploader/FileUploader";
import ProgressLoader from "../../components/ProgressLoader/ProgressLoader";
import { useLanguage } from '../../context/Languagecontext';
import FallBackLabel from '../../global/Globals_Eng.json';
const EditBrief = (props) => {
  const { Globals ,languages, setLanguages } = useLanguage();
  const dispatch=useDispatch();
  const [popupState, setPopupState] = useState(null);
  const [isValidated, setValidated] = useState(false); // default to false
  const [isExpanded, setIsExpanded] = useState(true);
  const [currencyName, setCurrencyName] = useState([]);
  const [submitTrigger, setSubmitTrigger] = useState(false);
  const [data, setData] = useState({});
  const [proposalData1, setproposalData1]=useState([])
  const location = useLocation();
  const { row } = location.state || {};
  const navigate = useNavigate();
  const [formValues, setFormValues] = useState([]);
  const [formValues1, setFormValues1] = useState([]);
    const [isRegFailed, setRegFailure] = useState(false);
    const [retryStatus, setretryStatus] = useState();
    const [data2, setData2] = useState();
    const [intialData, setInitialData] = useState();
    const doesFormHaveValues = useSelector(state => state.applyBrief.isProposalDetailsPartiallyFilled);
    const [files,setFiles]=useState({lookBoardMoodBaord1:'',productionSchedule1:'',reel:'',cer:'',reg:''})
  const [productionTypeName, setProductionTypeName]=useState('');
  const proposalId = row;
  const handleFormDataChange = (data,val) => {
      setFormValues(data);
        val==='' && setValidated(false)
  };
  const fileUpload = (key, value) => {
    setFiles((prev) => ({
      ...prev, // Spread the previous state to retain existing properties
      [key]: value, // Add or update the key with the new value
    }));
  };
  const setFileItems1 = (documents) => {
    setFiles((prevFiles) => {
      const updatedFiles = { ...prevFiles };
  
      documents.forEach((document) => {
        // Map `documentFor` to your state keys
        const keyMap = {
          LBMB: "lookBoardMoodBaord1",
          PRSCH: "productionSchedule1",
          SHWRL: "reel",
          CPRC: "cer",
          RDOC: "reg"
          // Add other mappings here
        };
  
        const matchingKey = keyMap[document.documentFor];
  
        if (matchingKey) {
          updatedFiles[matchingKey] = {
            name: document?.documentName?.trim(), // Trim to remove extra spaces
            type: document?.documentType,
            path: document?.documentPath,
            uploadedAt:document?.uploadedAt,
            documentId:document?.documentId
          };
        }
      });
  
      return updatedFiles;
    });
  };
  const [loading,setLoading]=useState(false)
  
   const handleBack = async () => {
      retryStatus==='' && setretryStatus(popupState)
    
      if(popupState==="cross" || retryStatus === "cross" ){
        setRegFailure(false);
        navigate(OldGlobals.NAVPATH.HOME, { state: { activeHeader: "proposals",success:true,draft:false, discard:true } })
      }
      else if (popupState==="brief" || retryStatus === "brief" ) {
       
        // setSubmitTrigger(true);
        try {
          setLoading(true)
          const response = await updateProposal(postData(proposalId, formValues, 0,undefined,files,intialData));
          setLoading(false)
          if(response.data.status!=="OK"){
            setRegFailure(true);
          }
              else if (response.data.content) {
                const success=response?.data?.content
                navigate(OldGlobals.NAVPATH.HOME, { state: { activeHeader: "proposals",success,user: "producer"}})
               resetSates();
              }
              else {
                  setRegFailure(true);
              }
        } catch (error) {
          setLoading(false)
          setRegFailure(true);
          console.error("Error in fetching brief info", error);
        }
      } else if (popupState==="draft" || retryStatus === "draft") {
        try {
          setLoading(true)
          const response = await updateProposal(postData(proposalId, formValues,1,undefined,files,intialData));
          setLoading(false)
          if(response.data.status!=="OK"){
            setRegFailure(true);
          }
              else if (response.data.content) {
                const success = response?.data?.content
            navigate(OldGlobals.NAVPATH.HOME, { state: { activeHeader: "proposals", success, draft: true,user: "producer" } })
                setRegFailure(false);
                resetSates();
              }
              else {
                  setRegFailure(true);
              }
        } catch (error) {
          setLoading(false)
          setRegFailure(true);  
          console.error("Error in fetching brief info", error);
        } 
      }
     
    };

  const handleTextArea = (type, message) => {};

  const handleButtonClick = (type) => {
    // setSubmitTrigger(true);
    setretryStatus('')
    setPopupState('')
    setSubmitTrigger(!submitTrigger);
    if(type === 'brief'){
      isValidated && setPopupState(type);
    }
    else if (type === 'draft') {
      setPopupState(type);
    }
     else {
      // setSubmitTrigger(true);
      setPopupState(type);
    }
  };

  const getBriefByProposalId = async (proposalId) => {
    try {
      const response = await fetch_Brief_Proposals(proposalId);
      setData([response.data.content]);
      setProductionTypeName(response?.data?.content?.productionTypeName);
    } catch (error) {
      console.error("Error in fetching brief info", error);
    }
  };

  const getCurrencyName = async () => {
    try {
      const response = await getAllCurrencyName();
      const currencyNames = response.data.content.Currencies.map(
        (item) => item.name
      );
      setCurrencyName(currencyNames);
      setData2(response.data.content)
    } catch (error) {
      console.error("Error in fetching brief info", error);
    }
  };
const[fileItems,setFileItems]=useState([])
  const getProposalDetails = async (producerId,proposalId,proposalDetailId) => {
    try {
        const response = await fetchProposalDetails(producerId,proposalId,proposalDetailId);
        const payload={response}
        setFormValues(response.data.content)
        setFormValues1([response.data.content])
        handleFormDataChange(response.data.content,true)
        setFileItems(response.data.content.documents)
        const proposalData1 = mapResponseToFormFields(response.data.content, Globals);
        setFileItems1(response.data.content.documents)
        setproposalData1(proposalData1)
      } catch (error) {
        console.error("Error in fetching brief info", error);
      }
  };


  useEffect(() => {
    getBriefByProposalId(row?.proposalId||'1501c377-264d-4584-9aa5-09e2ce0a1562');
    getCurrencyName();
    getProposalDetails('0efd507f-04ec-48a8-a92b-9d7dd8eedceb',row?.proposalId || '1501c377-264d-4584-9aa5-09e2ce0a1562', row?.proposalDetailId)
  }, []);
  function validateFormFields(formFields) {
    let isValid = true;

    let isEpisodevalid=(data?.[0]?.formatType  === "M" || data?.[0]?.formatType  === "E" )?'':'episodeStructure';
    let keysToOmit = ['updatedBy','status','createdBy','certCopyRightRegistration','regulatoryDocument','proposalDetailId','reel','proposalId','propRefNo','locationStudioInfo','lookBoardMoodBaord1','productionSchedule','lookBoardMoodBaord','castPresenterInfo','showReel','certCopyRightRegistration','regulatoryDocument','cer','reg',isEpisodevalid];
    if (productionTypeName && (productionTypeName !== Globals.ADVERTISER_PROGRAMME)) {
      keysToOmit.push('brandIntegration');
    }
    if (productionTypeName && (productionTypeName === Globals.ADVERTISER_PROGRAMME)) {
      keysToOmit = keysToOmit.filter(key => key !== 'brandIntegration');
    }
    // Check if formFields is an array
    if (Array.isArray(formFields)) {
        formFields.forEach(field => {
            for (const [key, value] of Object.entries(field)) {
                if (!value || value === "00000000-0000-0000-0000-000000000000") {
                    isValid = false;
                    break;
                }
            }
        });
    } else if (typeof formFields === 'object') { // Check if formFields is an object
        for (const [key, value] of Object.entries(formFields)) {
          if (keysToOmit.includes(key)) {
            continue; // Skip the keys that should be omitted from the check
          }
            if (!value) {
                isValid = false;
                break;
            }
        }
    } else {
        isValid = false; // Invalid input type
    }
    
    return isValid;
} 
  // New useEffect to validate form values
  useEffect(() => {
    const requiredFields = [
      "targetBudget"
    ];

    const isValid = requiredFields.every((field) => formValues[field]);
    const isFormValid = validateFormFields(formValues) && validateFormFields(files);
    isFormValid ? setValidated(true):setValidated(false)
  }, [formValues,files,productionTypeName]);

  const showPopup = (title, message, button1, button2 = null) => {
    if(popupState==="cross"){
      return (
        <Popup
        title={title}
        text={message}
        negativeAction={handleBack}
        negativeActionText={button1}
        // popupType={"abort"}
        onClose={() => {
          setRegFailure(false)
          setPopupState('')
         }}
        buttonBGColor={popupState !== "cross" ? "#004894" : ""}
      />
      );
    }
    else{
      return (
        <Popup  onClose={() => {
          setRegFailure(false)
          setPopupState('')
         }}
                    text={message || ''}
                    title={title || ''}
                normalAction={handleBack}
                    negativeActionText={button1}
                    normalActionText={popupState === "draft"?Globals.SAVE_AS_DRAFT:Globals.SUBMIT_PROPOSAL}
                />
      );
    }
  
  };
  function displayFileNames(documentFor) {
    const filteredFiles = fileItems.filter((item) => item.documentFor === documentFor);
    return filteredFiles
  }
  const handleFileRemoveShowReelFile =()=>{
    const newFormData = { ...formValues };
    newFormData["showReel"] = undefined;
    fileUpload("reel",'')
    setFormValues(newFormData);
  }
  const  handleFileRemoveCertificatePdfFile=()=>{
    const newFormData = { ...formValues };
    newFormData["certCopyRightRegistration"] = undefined;
    fileUpload("cer",'')
    setFormValues(newFormData);
  }
  const handleFileRemoveRegulatoryDocPdfFile =()=>{
    const newFormData = { ...formValues };
    newFormData["regulatoryDocument"] = undefined;
    fileUpload("reg",'')
    setFormValues(newFormData);
  }
  const resetSates = () => {
    // setPopupState("");
    setRegFailure(false)
  };

  const buttonUI = () => {
    return (
      <div>
        {/* Buttons */}
        <div className="apply-brief-button-group-container">
          <div className="apply-brief-button-group">
            <button
              className="apply-brief-cancel-btn"
              onClick={() => handleButtonClick("cross")}
            >
              {Globals.CREATE_NEW_BRIEF.CANCEL_BUTTON}
            </button>
            <button
              onClick={() => handleButtonClick("draft")}
               className={`${(doesFormHaveValues || formValues["regulatoryDocument"] || formValues["certCopyRightRegistration"]) ? "apply-brief-draft-btn"
                : "apply-brief-draft-btn-disabled"}`}
              disabled={!doesFormHaveValues && formValues["regulatoryDocument"] === undefined && formValues["certCopyRightRegistration"] === undefined}
            >
              {Globals.CREATE_NEW_BRIEF.SAVE_AS_DRAFT}
            </button>
            <Button
              title={Globals.SUBMIT_PROPOSAL}
              additionalStyle={
                (isValidated && (files?.productionSchedule1?.name !== undefined))
                  ? "apply-brief-create-btn"
                  : "apply-brief-create-btn-disabled"
              }
              id="Create-Brief-Button"
              action={() => {
                handleButtonClick("brief");
              }}
              disable={!isValidated} // Disable button when not validated
            />
          </div>
        </div>
        {popupState &&
          showPopup(
            Globals.APPLY_BRIEF.POPUP[popupState].TITLE,
            `${Globals.APPLY_BRIEF.POPUP[popupState].MESSAGE}${popupState === "brief" ? ` "${formValues?.projectTitle}" to ${data?.[0]?.channelName}?`: ''}`,
            Globals.APPLY_BRIEF.POPUP[popupState].BUTTON_TEXT
          )}
             {isRegFailed &&
         <div className='popup-bg'><Popup title={(popupState||retryStatus=== Globals.DRAFT)?Globals.SOLICITED_FAILED_SAVE_POPUP_TITLE:Globals.SOLICITED_FAILED_POPUP_TITLE}
         text={Globals.UNSOLICITED_FAILED_POPUP_MESSAGE}
         normalAction={()=>{handleBack()}}
         normalActionText={Globals.SIGNUP.POPUP.FAILURE.BUTTON_TEXT}
         popupType={"failed"}
         onClose={() => {
          setRegFailure(false)
          setPopupState('')
         }
          }
     // clearData={clearCheckedList}
     // resetPolicy={resetCheckBox}
     /></div>}
      </div>
    );
  };

  const handleShowReelFile =(file)=>{
    const newFormData = { ...formValues };
    newFormData["showReel"] = file;
    setFormValues(newFormData);
    fileUpload("reel",file)
    // setReel(file)
  }
  const handleCertificatePdfFile=(file)=>{
    const newFormData = { ...formValues };
    newFormData["certCopyRightRegistration"] = file;
    setFormValues(newFormData);
    fileUpload("cer",file)
    // setCert(file)
  }
  const handleRegulatoryDocPdfFile=(file)=>{
    const newFormData = { ...formValues };
    newFormData["regulatoryDocument"] = file;
    setFormValues(newFormData);
    fileUpload("reg",file)
  }

  return (
    <div className="apply-brief-container">
      <GenericHeader
        title={Globals.APPLY_BRIEF.TITLE}
        onClose={() => handleButtonClick("cross")}
      />
      {/* Basic details */}
      <BasicDetails
        setIsExpanded={setIsExpanded}
        isExpanded={isExpanded}
        data={data}
        data1={data}
        
      />
      {/* Proposal details */}
      {proposalData1.length && <ProposalDetails
        details={proposalData1}
        handleTextArea={handleTextArea}
        onFormDataChange={handleFormDataChange}
        submitTrigger={submitTrigger}
        currentList={currencyName}
        proposalData={proposalData1}
        data={formValues}
        formValues={formValues1}
        currencyData={data2}
        fileUpload={fileUpload}
        episodeShow={(data?.[0]?.formatType  === "M" || data?.[0]?.formatType  === "E" )}
        productionType={data?.[0]?.productionTypeName}
      />}
      {/* Company Information */}
      {/* <CompanyInformation /> */}
      <div className="apply-brief-company-info-container">
      <label className="brief-basic-details-text">
        {Globals.APPLY_BRIEF.COMPANY_INFORMATION}
      </label>
      {fileItems.length ?<>
        <div className="brief-apply3-container">
        {/* Showreel Upload */}
        <div className="brief-apply3-card">
          <label className="brief-apply3-title">
            {Globals.APPLY_BRIEF.SHOW_REEL}
            {/* <span className="required"> *</span> */}
          </label>
          
          <FileUploader
            onFileRemove={handleFileRemoveShowReelFile}
            {...(fileItems?.find(doc => doc.documentFor === "SHWRL")?.documentName && { fileDownload: displayFileNames("SHWRL") })}
            supportedFileType="VideosOnly"
            onFileUpload={(file)=>handleShowReelFile(file)}
            className="brief-apply3-file-wrapper"
          />
        </div>

        {/* Certificate Upload */}
        <div className="brief-apply3-card">
          <label className="brief-apply3-title">
            {Globals.APPLY_BRIEF.CERTIFICATE}
            {/* <span className="required"> *</span> */}
          </label>
          <FileUploader
            onFileRemove={handleFileRemoveCertificatePdfFile}
            {...(fileItems?.find(doc => doc.documentFor === "CPRC")?.documentName && { fileDownload: displayFileNames("CPRC") })}
            supportedFileType="pdfOrDocOnly" 
            onFileUpload={(file)=>handleCertificatePdfFile(file)}
            className="brief-apply3-file-wrapper"
          />
        </div>

        {/* Regulatory Documentation Upload */}
        <div className="brief-apply3-card">
          <label className="brief-apply3-title">
            {Globals.APPLY_BRIEF.REGULAROTY}
            {/* <span className="required"> *</span> */}
          </label>
          <FileUploader
            onFileRemove={handleFileRemoveRegulatoryDocPdfFile}
            {...(fileItems?.find(doc => doc.documentFor === "RDOC")?.documentName && { fileDownload: displayFileNames("RDOC") })}
            supportedFileType="pdfOrDocOnly" 
            onFileUpload={(file)=>handleRegulatoryDocPdfFile(file)}
            className="brief-apply3-file-wrapper"
          />
        </div>
      </div>
      </>: <div className="brief-apply3-container">
        {/* Showreel Upload */}
        <div className="brief-apply3-card">
          <label className="brief-apply3-title">
            {Globals.APPLY_BRIEF.SHOW_REEL}
            {/* <span className="required"> *</span> */}
          </label>
          
          <FileUploader
            onFileRemove={handleFileRemoveShowReelFile}
            supportedFileType="VideosOnly"
            onFileUpload={(file)=>handleShowReelFile(file)}
            className="brief-apply3-file-wrapper"
          />
        </div>

        {/* Certificate Upload */}
        <div className="brief-apply3-card">
          <label className="brief-apply3-title">
            {Globals.APPLY_BRIEF.CERTIFICATE}
            {/* <span className="required"> *</span> */}
          </label>
          <FileUploader
            onFileRemove={handleFileRemoveCertificatePdfFile}
            supportedFileType="pdfOrDocOnly" 
            onFileUpload={(file)=>handleCertificatePdfFile(file)}
            className="brief-apply3-file-wrapper"
          />
        </div>

        {/* Regulatory Documentation Upload */}
        <div className="brief-apply3-card">
          <label className="brief-apply3-title">
            {Globals.APPLY_BRIEF.REGULAROTY}
            {/* <span className="required"> *</span> */}
          </label>
          <FileUploader
            onFileRemove={handleFileRemoveRegulatoryDocPdfFile}
            supportedFileType="pdfOrDocOnly" 
            onFileUpload={(file)=>handleRegulatoryDocPdfFile(file)}
            className="brief-apply3-file-wrapper"
          />
        </div>
      </div>
}
     
    </div>
      {buttonUI()}
      {loading && <ProgressLoader width={50} height={50} component={"Solicated-Edit"}/>}
    </div>
  );
};

export default EditBrief;
